import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import groupBy from 'lodash/groupBy';
import moment from 'moment-timezone';

import LiveWebinarList from './LiveWebinarList';
import DaySelector from './DaySelector';

const WebinarListContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingIndicator = withStyles(() => ({
  root: {
    marginTop: '28px',
  },
}))(CircularProgress);

const LiveListContainer = ({ webinars, isLoading }) => {
  const [activeDay, setActiveDay] = useState(0);
  const webinarsByDays = groupBy(
    webinars,
    ({ startAt, timezone }) => moment.tz(startAt, timezone).format('ddd, MMM DD'),
  );
  const selectableDays = useMemo(() => Object.keys(webinarsByDays), [webinarsByDays]);

  const onDaySelected = (selectedIndex) => {
    setActiveDay(selectedIndex);
  };

  return (
    <WebinarListContainer>
      {
        isLoading ? (
          <LoadingIndicator />
        ) : (
          <>
            {selectableDays.length > 1 && (
              <DaySelector
                days={selectableDays}
                activeIndex={activeDay}
                onDaySelected={onDaySelected}
              />
            )}
            <LiveWebinarList webinars={Object.values(webinarsByDays)[activeDay]} />
          </>
        )
      }
    </WebinarListContainer>
  );
};

LiveListContainer.propTypes = {
  webinars: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
};

LiveListContainer.defaultProps = {
  webinars: [],
};

export default LiveListContainer;
